import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

const allowedPages = ['uam', 'dashboard', 'wallet'];
function Approval() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem('approval_link', location.pathname);
    const link = location.pathname;
    if (link) {
      const links = link?.trimStart()?.split('/');
      if (links?.length > 2) {
        const redirectPage = links[2];
        if (allowedPages.includes(redirectPage)) {
          navigate(`/${redirectPage}`);
        } else {
          localStorage.removeItem('approval_link');
        }
      } else {
        localStorage.removeItem('approval_link');
      }
    }
  }, []);

  return (
    <div>
      <div className='medium3' style={{ textAlign: 'center', margin: '20px 0px' }}>
        Redirecting...
      </div>
      <div style={{ justifyContent: 'center', display: 'flex' }}></div>
    </div>
  );
}

export default Approval;
